import { connect } from 'react-redux'
import Dashboard from './Dashboard'
import { getCompanyEmployees, getSpecificCompanyDashboard, setCompanyEmployees } from './store/DashboardActions'
import { userCompaniesSelector } from '../Settings/store/SettingsSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { companyDashboardSelector, employeesSelector } from './store/DashboardSelectors'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import { CompanyId, Role } from '../../services/api.types'

const mapStateToProps = (state: IGlobalState) => ({
  companyDashboard: companyDashboardSelector(state),
  employees: employeesSelector(state),
  userCompanies: userCompaniesSelector(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
})

const mapDispatchToProps = {
  getSpecificCompanyDashboard,
  getCompanyEmployees,
  setCompanyEmployees,
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
